
export default {
    actions: {
        executeUnauthenticated: 'https://kiosk-dev.pongstudios.ca/api/UnauthenticatedTerminal/',
    }
};